// Web mock for react-native-image-picker using file input
export interface ImagePickerResponse {
  didCancel?: boolean;
  errorCode?: string;
  errorMessage?: string;
  assets?: Array<{
    uri?: string;
    type?: string;
    fileName?: string;
    fileSize?: number;
    width?: number;
    height?: number;
    base64?: string;
  }>;
}

type Callback = (response: ImagePickerResponse) => void;

function createFileInput(accept: string, capture?: string): HTMLInputElement {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = accept;
  if (capture) {
    input.setAttribute('capture', capture);
  }
  return input;
}

function handleFileSelect(input: HTMLInputElement): Promise<ImagePickerResponse> {
  return new Promise(resolve => {
    input.onchange = () => {
      const file = input.files?.[0];
      if (!file) {
        resolve({ didCancel: true });
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        const img = new Image();
        img.onload = () => {
          resolve({
            assets: [
              {
                uri: URL.createObjectURL(file),
                type: file.type,
                fileName: file.name,
                fileSize: file.size,
                width: img.width,
                height: img.height,
              },
            ],
          });
        };
        img.onerror = () => {
          resolve({
            assets: [
              {
                uri: URL.createObjectURL(file),
                type: file.type,
                fileName: file.name,
                fileSize: file.size,
              },
            ],
          });
        };
        img.src = reader.result as string;
      };
      reader.readAsDataURL(file);
    };

    input.oncancel = () => {
      resolve({ didCancel: true });
    };

    input.click();
  });
}

export function launchImageLibrary(
  options: any,
  callback?: Callback
): Promise<ImagePickerResponse> {
  const input = createFileInput('image/*,video/*');
  const promise = handleFileSelect(input);
  if (callback) {
    promise.then(callback);
  }
  return promise;
}

export function launchCamera(
  options: any,
  callback?: Callback
): Promise<ImagePickerResponse> {
  const input = createFileInput('image/*', 'environment');
  const promise = handleFileSelect(input);
  if (callback) {
    promise.then(callback);
  }
  return promise;
}

export default {
  launchImageLibrary,
  launchCamera,
};
